import { Injectable } from '@angular/core';
import { ApiService, UserService } from '../../index';
@Injectable()
export class ThongKeChatLuongHeThongService {

  APIURL = "api/ExcuteOracle";
  constructor(private apiService: ApiService, private userService: UserService) { }
  thongKeChatLuongHeThong(danhmucid, maduan, thoigian, xemtrongngay) {
    let currUser = this.userService.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_THONGKE_CHATLUONG_HT.P_LAY_THONGKE_CHATLUONG"}',
      "para": '{"v_danhmucid":"' + danhmucid + '","v_duan":"' + maduan + '","v_thoigian":"' + thoigian + '","v_isngay":"' + xemtrongngay + '","v_mataikhoan":"' + currUser.mataikhoan + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }
  exportExcelChatLuongHeThong(data, filename, title, header, sheetname) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tendanhmuc", "label": "Đơn vị", "horizontalalignment": "left" },
      { "name": "docthanhcong", "label": "Đọc thành công", "horizontalalignment": "center" },
      { "name": "khongdulieu", "label": "Chưa có dữ liệu", "horizontalalignment": "center" },
      { "name": "tong", "label": "Tổng điểm đo", "horizontalalignment": "center" },
      { "name": "tyle", "label": "Tỷ lệ đọc thành công", "horizontalalignment": "center" },
    ];
    var param = {
      config: "",
      para: "",
      title: title,
      header: header,
      filename: "",
      sheets: sheetname,
      columns: columns,
      data: JSON.stringify(data)
    };
    return this.apiService.downloadFile("api/ExportExcel", param, filename + ".xlsx");
  }

  saveExcel(data, filename, title, header, sheetname, danhmucid) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "tendanhmuc", "label": "Đơn vị", "horizontalalignment": "left" },
      { "name": "docthanhcong", "label": "Đọc thành công", "horizontalalignment": "center" },
      { "name": "khongdulieu", "label": "Chưa có dữ liệu", "horizontalalignment": "center" },
      { "name": "tong", "label": "Tổng điểm đo", "horizontalalignment": "center" },
      { "name": "tyle", "label": "Tỷ lệ đọc thành công", "horizontalalignment": "center" }
    ];
    let currUser = this.userService.getCurrentUser();
    var param = {
      config: "",
      para: "",
      title: title,
      header: header,
      filename: "Báo cáo chất lượng hệ thống.xlsx",
      sheets: sheetname,
      columns: columns,
      data: JSON.stringify(data),
      mataikhoan: currUser.mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 4,
      tenbaocao: "Báo cáo chất lượng hệ thống",
    };
    return this.apiService.Excute("api/saveexcel", param);
  }

  getListChiTietDiemDoLoi(danhmucid, maduan, thoigian, xemtrongngay, phanbiet, pagenum, numrecs) {
    let currUser = this.userService.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_THONGKE_CHATLUONG_HT.P_LAYDS_DIEMDO_LOI"}', //PKG_THONGKE_CHATLUONG_HT
      "para": '{"v_danhmucid":"' + danhmucid + '","v_duan":"' + maduan + '","v_thoigian":"' + thoigian + '","v_isngay":"' + xemtrongngay + '","v_phanbiet":"' + phanbiet + '","v_pagenum":"' + pagenum + '","v_numrecs":"' + numrecs + '","v_mataikhoan":"' + currUser.mataikhoan + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }

  getDSLoaiLoi() {
    var param = {
      "config": '{"namesql":"PKG_THONGKE_CHATLUONG_HT.P_LAYDS_LOAILOI"}',
      "para": ''
    };
    return this.apiService.Excute(this.APIURL, param);
  }

  insertDSDiemDoLoi(dsdiemdoloi) {
    var param = {
      "config": '{"namesql":"PKG_THONGKE_CHATLUONG_HT.P_THEM_LOAILOI_DIEMDO"}',
      "para": '{"v_data":"' + dsdiemdoloi + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }

  exportExcelChiTietLoiDiemDo(danhmucid, maduan, thoigian, xemtrongngay, phanbiet, tendonvi, tenchucnang, noidungbaocao) {
    let currUser = this.userService.getCurrentUser();
    let cols = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
      { "name": "diachi", "label": "Đơn vị", "horizontalalignment": "left" },
      { "name": "tenloi", "label": "Tên lỗi", "horizontalalignment": "left" },
    ];
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_duan: maduan,
      v_thoigian: thoigian,
      v_isngay: xemtrongngay,
      v_phanbiet: phanbiet,
      v_mataikhoan: currUser.mataikhoan,
      v_pagenum: 0,
      v_numrecs: 1000000,
    });
    let config = JSON.stringify({ namesql: "PKG_THONGKE_CHATLUONG_HT.P_LAYDS_DIEMDO_LOI" });
    return this.apiService.exportExcel("", cols, para, config, tendonvi, tenchucnang, noidungbaocao, thoigian);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/thong-ke-trang-thai/thong-ke-chat-luong/thongkechatluonghethong.service.ts